// WhatsApp del negocio: un solo número para todo el negocio (Ajustes → WhatsApp Business). Los enlaces de los anuncios de todas las
// campañas llevan a él. Funciones puras, con pruebas.
import { numeroDesde } from './importar';
import { telefonoTexto } from './paises';

// "573000000099" → "+57 300 000 0099".
export const telNegocio = (n: string): string => { const x = numeroDesde('+' + n, null, 'CO'); return telefonoTexto('pais' in x ? x.pais : null, n); };

// Lo que escribe la usuaria ("300 000 0099", "+57 300 000 0099"…) a lo que se guarda (dígitos con indicativo) o al error que se le muestra.
export function validarWhatsApp(texto: string): { whatsapp: string } | { error: string } {
  if (!texto.trim()) return { error: 'Escribe el WhatsApp del negocio, con indicativo (por ejemplo +57 300 000 0000).' };
  const x = numeroDesde(texto, null, 'CO');
  return 'error' in x ? { error: 'Revisa el número: con indicativo, por ejemplo +57 300 000 0000.' } : { whatsapp: x.whatsapp };
}
